jQuery(document).ready(function() {
    if(jQuery('.radio-asset-select').length) {
        jQuery('.js-radio-asset-select-option-img-wrapper').on('click', function() {
            jQuery(this).addClass('active').closest('.radio-asset-select__option').siblings().find('.js-radio-asset-select-option-img-wrapper').removeClass('active');

            jQuery('.singing-cans-form').removeClass('active');

            jQuery('.' + jQuery(this).data('target')).addClass('active');

            let formOffset = jQuery('.singing-cans-form.active').offset().top;

            jQuery('html, body').animate({ scrollTop: formOffset }, 'slow');
        })
    }
});
